import React from 'react';
import { Inbox, LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: LucideIcon;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  icon: Icon = Inbox,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '64px 24px',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          width: 56,
          height: 56,
          borderRadius: 'var(--radius-lg)',
          background: 'var(--neutral-200)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 16,
          color: 'var(--neutral-400)',
        }}
      >
        <Icon size={28} />
      </div>
      <h3 style={{ fontSize: 16, fontWeight: 600, color: 'var(--neutral-800)', marginBottom: 4 }}>
        {title}
      </h3>
      {description && (
        <p style={{ fontSize: 14, color: 'var(--neutral-500)' }}>{description}</p>
      )}
    </div>
  );
};